import {useCallback} from 'react'
import {getClickType, isTrackableAlternativeClick} from 'utils/clickType'
import {SelectedElement} from 'utils/selectedElement'

import {getClosestDataIdToEventTarget} from '@vio/core/src/_web/utils/browser'

import {
  TrackUserHotelCardClickedParameters,
  useHotelCardActions
} from './useHotelCardActions'

interface Props {
  hotelId: string
  component: TrackUserHotelCardClickedParameters['component']
  highlights?: string[]
}

/**
 * Right, middle and long-press clicks open the card without firing a plain
 * `click`, so the card click goes untracked without this. Wire it only on
 * elements that are real links; elsewhere the gesture opens nothing and
 * tracking it would report a click that never happened.
 */
export const useHotelCardAlternativeClick = ({
  hotelId,
  component,
  highlights
}: Props) => {
  const {trackUserHotelCardClicked} = useHotelCardActions()

  return useCallback(
    (event: React.MouseEvent) => {
      if (!isTrackableAlternativeClick(event)) return

      trackUserHotelCardClicked({
        hotelId,
        component,
        selectedElement:
          getClosestDataIdToEventTarget(event) || SelectedElement.BlankSpace,
        highlights,
        clickType: getClickType(event)
      })
    },
    [trackUserHotelCardClicked, hotelId, component, highlights]
  )
}
